export const ADD_COMMUNITY_NOTIFICATION = "ADD_COMMUNITY_NOTIFICATION";
export const CLEAR_ALL_COMMUNITY_NOTIFICATIONS = "CLEAR_ALL_COMMUNITY_NOTIFICATIONS";
export const REMOVE_COMMUNITY_NOTIFICATION = "REMOVE_COMMUNITY_NOTIFICATION";
export const UPDATE_COMMUNITY_NOTIFICATION = "UPDATE_COMMUNITY_NOTIFICATION";
export const UPDATE_COMMUNITY_NOTIFICATIONS_AS_READ =
  "UPDATE_COMMUNITY_NOTIFICATIONS_AS_READ";
export const REMOVE_COMMUNITY_NOTIFICATIONS_RELATED_TO_COMMUNITY =
  "REMOVE_COMMUNITY_NOTIFICATIONS_RELATED_TO_COMMUNITY";
